// src/components/AvvisoViola.js
// Messaggio informativo di Nexiora (ottobre 2026): testo viola in un riquadro chiaro con
// il bordo viola. Prende il posto dei riquadri a fondo viola pieno, che risultavano
// invasivi (benvenuto in Home, spiegazioni delle Segnalazioni cliente, avvisi nei menu).
import React from "react";

export const STILE_AVVISO_VIOLA = {
  background: "#faf5ff", color: "#5b21b6", border: "1px solid #ddd6fe", borderLeft: "4px solid #7c3aed",
  borderRadius: 10, lineHeight: 1.5,
};

export default function AvvisoViola({ children, compatto = false, style }) {
  return (
    <div style={{ ...STILE_AVVISO_VIOLA, padding: compatto ? "7px 10px" : "10px 14px", fontSize: compatto ? 11.5 : 12.5, ...style }}>
      {children}
    </div>
  );
}
